import React from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";

export default function ProvisaoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { status: 'provisoria' }
    });
    const { handleSubmit } = methods;

    const tipoList = [
        { id: 'mao_obra', title: 'Mão de Obra' },
        { id: 'equipamentos', title: 'Equipamentos' },
        { id: 'comissao_vendedor', title: 'Comissão Vendedor' },
        { id: 'comissao_outro', title: 'Comissão Outro' },
        { id: 'engenheiro', title: 'Engenheiro' },
        { id: 'frete', title: 'Frete' },
        { id: 'outro', title: 'Outro' },
    ];

    const statusList = [
        { id: 'provisoria', title: 'Provisória' },
        { id: 'confirmada', title: 'Confirmada' },
        { id: 'cancelada', title: 'Cancelada' },
    ];

    return (
        <FormContainer size="lg" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data?.id ? 'Editar Provisão' : 'Nova Provisão'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <div className="col-12">
                                <fieldset>
                                    <legend>Vinculação</legend>
                                    <div className="row">
                                        <UiInputSuggest size={6} router="contrato" idField="id" titleField="id" name="contrato" label="Contrato" required />
                                        <UiInputSuggest size={6} router="centroCusto" idField="id" titleField="nome" name="centroCusto" label="Centro de Custo" />
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-12">
                                <fieldset>
                                    <legend>Dados da Provisão</legend>
                                    <div className="row">
                                        <UiInputList size={4} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo" required />
                                        <UiInputText size={8} name="descricao" label="Descrição" required />
                                        <UiInputMoney size={4} name="valorPrevisto" label="Valor Previsto" required />
                                        <UiInputMoney size={4} name="valorReal" label="Valor Real" />
                                        <UiInputList size={4} name="status" list={statusList} idField="id" titleField="title" label="Status" />
                                        <UiInputText size={12} name="observacoes" label="Observações" />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </FormContainer.Body>
                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
